import * as TruckTemplateActions from '../actions/truck-template';
import TruckService from '../../ports/TruckService';
import { apiCall } from '../actions/api-call';
import { Novel } from '../middlewares/novels';
import { Action } from '../actions';

export interface TruckTemplateNovels {
  getTruckTemplatesNovel: Novel<TruckTemplateActions.GetTruckTemplatesRequestAction, Action>;
  createTruckTemplateNovel: Novel<TruckTemplateActions.CreateTruckTemplatesRequestAction, Action>;
  updateTruckTemplateNovel: Novel<TruckTemplateActions.UpdateTruckTemplatesRequestAction, Action>;
  deleteTruckTemplateNovel: Novel<TruckTemplateActions.DeleteTruckTemplatesRequestAction, Action>;
}

export const truckTemplateNovelsCreator = (
  truckService: TruckService,
): TruckTemplateNovels => {
  const getTruckTemplatesNovel = async (
    {}: TruckTemplateActions.GetTruckTemplatesRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    try {
      dispatch(apiCall());
      const templates = await truckService.getTruckTemplates();
      dispatch(apiCall.success());
      dispatch(TruckTemplateActions.getTruckTemplates.success(templates));
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      dispatch(TruckTemplateActions.getTruckTemplates.failure(err.message));
    }
  };

  const createTruckTemplateNovel = async (
    { data }: TruckTemplateActions.CreateTruckTemplatesRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    try {
      dispatch(apiCall());
      const template = await truckService.createTruckTemplate(data);
      dispatch(apiCall.success());
      dispatch(TruckTemplateActions.createTruckTemplate.success(template));
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      dispatch(TruckTemplateActions.createTruckTemplate.failure(err.message));
    }
  };
  const updateTruckTemplateNovel = async (
    { data }: TruckTemplateActions.UpdateTruckTemplatesRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    try {
      dispatch(apiCall());
      const template = await truckService.updateTruckTemplate(data);
      dispatch(apiCall.success());
      dispatch(TruckTemplateActions.updateTruckTemplate.success(template));
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      dispatch(TruckTemplateActions.updateTruckTemplate.failure(err.message));
    }
  };
  const deleteTruckTemplateNovel = async (
    { data }: TruckTemplateActions.DeleteTruckTemplatesRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    try {
      dispatch(apiCall());
      await truckService.deleteTruckTemplate(data);
      dispatch(apiCall.success());
      dispatch(TruckTemplateActions.deleteTruckTemplate.success(data.id));
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      dispatch(TruckTemplateActions.deleteTruckTemplate.failure(err.message));
    }
  };

  return {
    getTruckTemplatesNovel,
    createTruckTemplateNovel,
    updateTruckTemplateNovel,
    deleteTruckTemplateNovel,
  };
};
